import { render, staticRenderFns } from "./IconSvgForYou.vue?vue&type=template&id=440d5f40&scoped=true&"
import script from "./IconSvgForYou.vue?vue&type=script&lang=js&"
export * from "./IconSvgForYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440d5f40",
  null
  
)

export default component.exports